module.exports={author:"Lily Yanagimoto",date:"10/20/2021",publishDate:"10/20/2021",highlighted:!1,badge:"",tags:"",title:"Votive"};